import Path from '../../../services/paths'
import utils from '../../common/utils'
import DurationAction from '../../prat_actions/gt/durationAction'

export default class GeoMiddleware {

    static get_startWeek(year,week){

        // console.log(year,week)
        let url = `${Path.GET_START_WEEK}?year=${year}&`;

    if (week) {
      url += `week=${week}&`;
    }

    url = url.slice(0, -1);

        return dispatch => {
            dispatch(DurationAction.startWeek_Request());
            utils.get_token()
            .then(token => {
                fetch(url, {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(DurationAction.startWeek_Success(data))
                })
                .catch(err => {
                    dispatch(DurationAction.startWeek_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(DurationAction.startWeek_Failed(err.message))

            })
        }
    };

    // END WEEK

    static get_endWeek(year,week){
        // console.log(year,week)
        let url = `${Path.GET_END_WEEK}?year=${year}&`;

    if (week) {
      url += `week=${week}&`;
    }

    url = url.slice(0, -1);
        return dispatch => {
            dispatch(DurationAction.endWeek_Request());
            utils.get_token()
            .then(token => {
                fetch(url, {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(DurationAction.endWeek_Success(data))
                })
                .catch(err => {
                    dispatch(DurationAction.endWeek_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(DurationAction.endWeek_Failed(err.message))

            })
        }
    };

  
}

